import { makeStyles } from '@fluentui/react-components';

export const useStackStyles = makeStyles({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        width: 'auto',
        height: 'auto',
        boxSizing: 'border-box'
    },
    vertical: {
        flexDirection: 'column'
    },
    horizontal: {
        flexDirection: 'row'
    },
    aligned: {
        alignItems: 'flex-start'
    },
    centerAligned: {
        alignItems: 'stretch'
    },
    spaced: {
        justifyContent: 'space-between'
    },
    centered: {
        justifyContent: 'center'
    },
    row: {
        flexDirection: 'row'
    },
    horizontalReverse: {
        flexDirection: 'row-reverse'
    },
    verticalReverse: {
        flexDirection: 'column-reverse'
    }
});
